<template>
    <div class="assets-summary">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
<!--                        <select name="test" class="form-control input-dropdown">-->
<!--                            <option value="123">123</option>-->
<!--                            <option value="321">321</option>-->
<!--                            <option value="567">567</option>-->
<!--                        </select>-->
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Assets Management
                            
                            <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>

                        </div>
                    </div>      

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button class="btn btn-ecdc" @click="$router.push({ name: 'assetsCreate' })">Create</button>
                            <button class="btn btn-ecdc ml-3" @click="$router.push({ name: 'assetsTransfer' })">Transfer</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="summary-list row row-cols-6">
                <div class="col">
                    <div class="summary-blue-card pointer" @click="$router.push({ name: 'assetsTabletsDetails' })">
                        <div class="card-content">
                            <h3 class="card-heading">
                                Tablets
                                <small>Inventory</small>
                            </h3>

                            <div class="figure">
                                {{ tabletSummary.total_tablets }}
                                <small>Units</small>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            Details
                        </div>
                    </div>
                </div>
            </div>


            <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
                <div class="col">
                    <div class="card data-card">
                        <div class="data-card-header">
                            <h3 class="card-heading">
                                Tablets Inventory
                            </h3>
                        </div>

                        <dl class="row no-gutters">
                            <dt class="col-8">
                                Available
                            </dt>
                            <dd class="col-4">
                                {{ tabletSummary.total_available }}
                            </dd>
                        </dl>

                        <dl class="row no-gutters">
                            <dt class="col-8">
                                Occupied
                            </dt>
                            <dd class="col-4">
                                {{ tabletSummary.total_occupied }}
                            </dd>
                        </dl>

                        <dl class="row no-gutters">
                            <dt class="col-8">
                                Damaged
                            </dt>
                            <dd class="col-4">
                                {{ tabletSummary.total_damaged }}
                            </dd>
                        </dl>

                        <dl class="row no-gutters">
                            <dt class="col-8">
                                Transferring
                            </dt>
                            <dd class="col-4">
                                {{ tabletSummary.total_transferring }}
                            </dd>
                        </dl>

                    </div>
                </div>
            </div>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import Loader from './Loader.vue'
import {getTabletSummary} from "../api";

export default {
    components: {
        appLoader: Loader,
        // appIconSearch: IconSearch,
    },
    data() {
        return {
            latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
            isLoading: true,
            tabletSummary: '',
        }
    },
    async mounted() {
        await this.getTabletSummary();
        this.isLoading = false;
    },
    methods: {
        async getTabletSummary() {
            let result = await getTabletSummary();
            this.tabletSummary = result.data;
        },
    }
}
</script>